/**
 * Project registration — ensures the current (partner/datacentral) project exists
 * in the monitoring service so watchpoints can reference it via FK. Idempotent;
 * called once on console entry.
 */
import { useMutation } from '@tanstack/react-query';
import { healthcheckApi, unwrap } from './_shared';

export interface RegisterProjectInput {
  id: string;
  name?: string;
}

export function useRegisterProject() {
  return useMutation<unknown, Error, RegisterProjectInput>({
    mutationFn: async (body) => unwrap(await healthcheckApi.post('/projects/register', body)),
  });
}
